"use client";

import { BannerSection } from "@/components/sections/BannerSection";
import { BasePricing } from "./sections/BasePricing";
import { PricingCalculator } from "./sections/PricingCalculator";
import { WhyUs } from "./sections/WhyUs";
import { BreadcrumbHomepage } from "@/components/sections/BreadcrumbHomepage";

export default function TarifsPage() {
  return (
    <>
      <main className="flex min-h-screen max-w-[100vw] flex-col">
        <BannerSection title="Tarifs" />
        <BreadcrumbHomepage className="text-white" />
        <BasePricing />
        <PricingCalculator />
        <WhyUs />
      </main>
    </>
  );
}
